import React from "react";
import SlickSlider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "./styles.scss";

const Slider: React.FC<Settings> = props => <SlickSlider {...props} />;

export default Slider;
